import { buildPaths } from '@front/logic/others/buildPaths'

const OnboardingRoutes = buildPaths({
  Onboarding: {
    PrivacyPolicy: {},
    ProfessionalSituation: {},
    Signup: {},
    SignupWelcome: {},
    SignupJobs: {},
    SignupSuccess: {},
    SignupDocuments: {
      type: {
        param: true,
      },
    },
    SignupPersonalInformation: {},
    TermsOfUse: {},
  },
})

export const OnboardingRoutesVariables = {
  Onboarding: OnboardingRoutes.Onboarding.path,
  OnboardingProfessionalSituation:
    OnboardingRoutes.Onboarding.ProfessionalSituation.path,
  OnboardingPrivacyPolicy: OnboardingRoutes.Onboarding.PrivacyPolicy.path,
  OnboardingSignup: OnboardingRoutes.Onboarding.Signup.path,
  OnboardingSignupJobs: OnboardingRoutes.Onboarding.SignupJobs.path,
  OnboardingSignupWelcome: OnboardingRoutes.Onboarding.SignupWelcome.path,
  OnboardingSignupSuccess: OnboardingRoutes.Onboarding.SignupSuccess.path,
  OnboardingSignupDocuments: OnboardingRoutes.Onboarding.SignupDocuments.path,
  OnboardingSignupDocumentDetails:
    OnboardingRoutes.Onboarding.SignupDocuments.type.getPath,
  OnboardingSignupPersonalInformation:
    OnboardingRoutes.Onboarding.SignupPersonalInformation.path,
  OnboardingTermsOfUse: OnboardingRoutes.Onboarding.TermsOfUse.path,
}
